<template>
    <span v-if="status === 'trialing'" class="px-2 inline-flex text-sm leading-5 font-medium rounded-md bg-blue-100 text-blue-800">Trial ends {{ next_billing }}</span>
    <span v-else-if="status === 'active'" class="px-2 inline-flex text-sm leading-5 font-medium rounded-md bg-green-100 text-green-800">{{
        status.replace(/\b\w/, v => v.toUpperCase())
    }}</span>
    <span v-else-if="status === 'canceled'" class="px-2 inline-flex text-sm leading-5 font-medium rounded-md bg-blue-100 text-blue-800">Subscription ends {{ cancel_at }}</span>
    <span v-else-if="status === 'past_due'" class="px-2 inline-flex text-sm leading-5 font-medium rounded-md bg-red-100 text-red-800">
        {{ status.replace(/\b\w/, v => v.toUpperCase()).replace('_', ' ') }}
    </span>
    <span v-else class="px-2 inline-flex text-sm leading-5 font-medium rounded-md bg-blue-100 text-blue-800">
        {{ status.replace(/\b\w/, v => v.toUpperCase()) }}
    </span>
</template>
<script>
export default {
    name: 'subscription-status',
    props: {
        status: String,
        next_billing: String,
        cancel_at: String,
    },
};
</script>

<style></style>
